export const ApplyButton = () => (
  <a
    href="https://form.respondi.app/9HBFdOhx"
    className="bg-green text-base md:text-lg font-bold py-3 px-5 md:py-7 md:px-12 rounded-lg mt-1 hover:bg-semidarkGreen"
  >
    Garanta sua Vaga Exclusiva na Consultoria
  </a>
);
